import React from 'react';

const logoStyle = {
  height: 60,
  display: 'block',
  margin: '0 auto',
};

const minHeight200 = {
  'min-height': '200px',
};

const textAlignCentre = {
  'text-align': 'center',
};

const textAlignCentre50p = {
  'text-align': 'center',
  padding: '0 50px',
};

const LOGO_URL = '/themes/theme/elemis/logo.png';
const IMG_ALT_TEXT = 'ELEMIS';
const SHARE_SITE_URL = 'https://share.elemis.com';
const ORGANISATION_ID = 'df27f0a0-7ad2-4161-b14e-f928b464a85b';
const INSTAGRAM_URL = 'https://www.instagram.com/elemis/';

const ShopfluenceTheme = {
  headerLogo: {
    src: LOGO_URL,
    alt: IMG_ALT_TEXT,
    size: 50,
  },
  darkLogo: {
    src: LOGO_URL,
    alt: IMG_ALT_TEXT,
  },
  headerStyle: {
    backgroundColor: '#fff',
    borderBottom: '2px solid #000',
    height: 110,
  },
  linkStyle: {
    color: '#000',
    fontWeight: 800,
    fontSize: '120%',
  },
  title: IMG_ALT_TEXT,
  isLightOnDark: false,
  loginMessage: (
    <div style={{ padding: '10px' }}>
      <br /><br />
      <img
        height="50"
        src={LOGO_URL}
        alt={IMG_ALT_TEXT}
      />
      <br /><br />
      <h3>influencer gifting</h3>
      <h4>powered by shopfluence</h4>
    </div>
  ),
  shareSite: SHARE_SITE_URL,
  organisationId: ORGANISATION_ID,
  instagramLabel: 'Instagram Handle (1,000+ Followers)',
  tiktokLabel: 'Tiktok Handle (1,000+ Followers)',
  dobLabel: 'Date of birth (You must be 16+ to sign up)',
  dobRequired: true,
  skipMainHandles: true,
  skipAdditionalHandles: true,    
  mediaKit: {
    avatarProps: {
      size: 'small',
      avatar: true,
      floated: 'left',
      style: {
        width: 150,
      },
    },
    logoProps: {
      floated: 'right',
      src: LOGO_URL,
      style: {
        width: 400,
        marginTop: 35,
      },
    },
  },
  primaryButtonColorStyle: {
    background: '#004f71',
    color: 'white',
    margin: 5,
  },
  tagButtonColor: 'violet',
  formTitle: () => (
    <h3 style={textAlignCentre}>
      Create your profile
    </h3>
  ),
  welcomeHtml: () => (
    <div style={minHeight200}>
      <h3 style={textAlignCentre}>welcome to {IMG_ALT_TEXT}</h3>

      <p style={textAlignCentre50p}>
        <img src="https://s3.eu-west-1.amazonaws.com/static.dyzio.co/superfood-midnight-facial.png" width="200px" />
      </p>
      <p>&nbsp;</p>
      <p style={textAlignCentre50p}>
      Sign up to receive exclusive <strong>ELEMIS</strong> products and <br />work with <strong>ELEMIS</strong> on their upcoming promotional campaigns.
      </p>

      <p>&nbsp;</p>
      <p style={textAlignCentre50p}>
      Once you have been selected you will be<br />sent discount codes to use in the store.
      </p>
      <br />
      <p style={textAlignCentre50p}>
      The {IMG_ALT_TEXT} campaign is delivered via <a href="https://shopfluence.app/" target="_blank">Shopfluence</a>.
      </p>
      <br />
    </div>
  ),
  signUpHtml: () => (
    <div style={minHeight200}>
      <p style={textAlignCentre}>
        If you sign up to an Elemis campaign,<br /> we hope that you will produce at least one piece of content according to our content brief.
      </p>
      <br />
      <p style={textAlignCentre}>
        Collaborators who produce good content<br />are more likely to be included in future campaigns.
      </p>
    </div>
  ),
  finishedHtml: () => (
    <div style={minHeight200}>
      <p style={textAlignCentre}>Thanks for signing up to the {IMG_ALT_TEXT} Shopfluence platform.
      We will review your application and get in touch with any suitable gifting campaigns for you.</p>
      <br />
      <p style={textAlignCentre}>Please head over to our instagram account (LINK BELOW) and hit the follow button.
      This is the best way to keep up to date with upcoming campaigns!!</p>
      <br />

      <br />
      <p style={textAlignCentre}>
        <a href={INSTAGRAM_URL}>
          <img
            href={INSTAGRAM_URL}
            className="logo"
            style={logoStyle}
            src={LOGO_URL}
            alt={IMG_ALT_TEXT}
          />
        </a>
        <a href={INSTAGRAM_URL}>Our Instagram page</a>
      </p>
      <br />
    </div>
  ),
  tagsHtmlTop: () => (
    <div>
      <div>Tags</div>
      <div className="spacer small" />
      <p style={textAlignCentre}>How would you describe your content style? (please select at least one)</p>
      <div className="spacer small" />
    </div>
  ),
  socialHandle2HtmlBottom: () => (
    <p style={textAlignCentre}>if none to add, please click next</p>
  ),
  socialHandle3HtmlBottom: () => (
    <p style={textAlignCentre}>if none to add, please click next</p>
  ),
  // tagsJson, //GIfta requested to hide the tags screen
  tiktokOnFrontPage: true,
  skipMainHandles: true,
  skipAdditionalHandles: true,
  hideLastCheckbox: false,
  signUpTitle: () => (
    <h3 style={textAlignCentre}>Collaboration Expectations</h3>
  ),
  socialHandle1HtmlTitle: () => (
    <div style={textAlignCentre}>
      <h3>Add your handles</h3>
      <p>enter your handle(s) and click look up</p>
    </div>
  ),
  confirmationTitle: () => (
    <div style={textAlignCentre}>
      <h3>Confirm your Elemis profile</h3>
      <p>The ELEMIS campaign is delivered via Shopfluence</p>
    </div>
  ),
  shopfluenceTitle: 'Shopfluence',
  extraCheckboxHtml: () => (
    <div style={textAlignCentre}>
    &nbsp;I am happy for ELEMIS to use my collaboration content<br /> in their promotional material.
    </div>
  ),
};

export default ShopfluenceTheme;



/** WEBPACK FOOTER **
 ** ./src/themes/theme/elemis.js
 **/